import {HttpService} from "./HttpService";
import {AdminHttpService} from "./SearchTableService";

export class InsuranceProviderHttpService {

    static async updateLogo(providerId: number, file: File): Promise<void> {
        const formData = new FormData();
        formData.append('logo', file);
        await HttpService.getLuxotticaAxios().put(
            `${AdminHttpService.URL_ADMIN_INSURANCE_PROVIDERS}/${providerId}/logo`,
            formData
        );
    }

}
